export default __webpack_public_path__ + "static/media/que.b195c2ea.png";